<template>
  <div class="passo1">
    <modal name="termo" width="80%" height="auto" :clickToClose="true" :scrollable="true">
      <div class="container">
        <div class="texto-termo"><strong>Estou ciente que:</strong></div>
        <ol class="texto-termo" type="a">
          <li>
            <span>As mensagens da CAIXA se limitam a textos e JAMAIS conterão links, endereços de e-mail, propagandas de terceiros e solicitação de senha pelos meios de comunicação: telefone celular, telefone fixo, mensagens de e-mail, SMS, chat, aplicativo WhatsApp;</span>
          </li>
          <li>
            <span>O envio de mensagens e contatos telefônicos têm prazo indeterminado, podendo ser cancelado mediante comunicação prévia, sem ônus para qualquer das partes, com comunicação de cinco dias úteis de antecedência;</span>
          </li>
          <li>
            <span>Haverá a consulta às informações consolidadas a respeito das operações de crédito e câmbio constantes em meu nome no SCR - BACEN, gerido pelo Banco Central do Brasil, ou dos sistemas que venham a complementá-lo ou a substituí-lo, nos termos das Resoluções BACEN nº 3.920/10 e 4.571/17;</span>
          </li>
          <li>
            <span>Serão fornecidas informações sobre as operações de crédito e câmbio por mim realizadas junto à CAIXA, a fim de compor o cadastro do SCR – BACEN, nos termos das Resoluções BACEN nº 3.920/10 e 4.571/17;</span>
          </li>
          <li>
            <span>Os meus dados cadastrais serão arquivados, nos termos das Resoluções BACEN nº 3.920/10 e 4.571/17;</span>
          </li>
          <li>
            <span>A CAIXA está autorizada a consultar e arquivar meus dados cadastrais e de idoneidade, nos serviços de proteção ao crédito com as quais mantém convênio firmado e que deles poderá se utilizar;</span>
          </li>
          <li>
            <span>O SCR – BACEN é um cadastro que visa prover o BACEN de informações para fins de monitoramento do crédito no sistema financeiro e para o exercício de suas atividades de fiscalização, sendo utilizado para propiciar o intercâmbio de informações entre instituições financeiras, conforme art. 4º da Resolução BACEN nº 4.571/17, sobre o montante de responsabilidades de clientes em operações de crédito e de câmbio;</span>
          </li>
          <li>
            <span>Poderei ter acesso aos dados constantes em meu nome no SCR por meio das Centrais de Atendimento ao Público do BACEN e/ou por meio do endereço http://www.bcb.gov.br;</span>
          </li>
          <li>
            <span>Os pedidos de correção e/ou exclusão das informações constantes do SCR deverão ser dirigidos à instituição responsável pela remessa das informações ao BACEN, por meio de requerimento escrito e fundamentado, ou, quando for o caso, por respectiva decisão judicial;</span>
          </li>
          <li>
            <span>O BACEN é autorizado a tornar disponíveis às Instituições, que podem consultar no SCR – BACEN, informações consolidadas sobre as minhas operações de crédito e de câmbio, respeitadas as regras estabelecidas pelo próprio BACEN;</span>
          </li>
          <li>
            <span>A falsidade dos dados declarados configura crime previsto na legislação brasileira, passível de responsabilização civil, criminal e administrativa, conforme a Lei n° 9.613/98, que dispõe sobre os crimes de "lavagem" ou ocultação de bens, direitos e valores com as alterações introduzidas, e dos arts. 297, 298 e 299 do Código Penal, podendo implicar na imediata revogação das avaliações de risco de crédito, das operações avaliadas e não contratadas e no vencimento antecipado das operações de crédito vigentes vinculadas a tais dados.</span>
          </li>
          <li>
            <span>Eventuais dúvidas podem ser sanadas nas agências da CAIXA, pelo Suporte Tecnológico Externo 3004 1104 (Capitais e regiões metropolitanas) e 0800 726 0104 (Demais regiões) ou pelo endereço eletrônico www.caixa.gov.br.</span>
          </li>
        </ol>
        <div class="botao-modal">
          <a class="btn blue" @click="retornoModal(true)">Ok</a>
        </div>
      </div>
    </modal>


    <modal name="appDesabilitado" :adaptive="true" height="auto" :clickToClose="false" :scrollable="true">
      <div class="container resumo-final-pf">
        <div class="colsm-12">
          <div class="tituloModal">Ops!</div>
          <p>Simulador desativado, tente novamente mais tarde.</p>
        </div>
      </div>
    </modal>

    <div class="container wp-box section section-artigo with-box">
      <h2>Soluções para você</h2>

      <div class="timeline">
        <div id="timeline-wrap">
          <div id="timeline"></div>
          <div class="marker mfirst timeline-icon one active">1</div>
          <div class="marker m2 timeline-icon two">2</div>
          <div class="marker m3 timeline-icon three">3</div>
          <div class="marker m4 timeline-icon four">4</div>
          <div class="marker m5 timeline-icon five">5</div>
          <div class="marker mlast timeline-icon six">6</div>
        </div>
      </div>
    </div>

    <div class="container wp-box section section-artigo with-box">
      <div class="row">
        <div class="colsm-12">
          <p>Olá, para iniciar a simulação precisamos conhecer um pouco mais sobre você:</p>
        </div>
      </div>
      <div class="form-passos">
        <div class="row">
          <div class="colsm-8">
            <div class="control-item">
              <label class="label-d">Nome:</label>
              <input
                type="text"
                name="nome"
                v-validate="'required'"
                v-model="dados.Nome"
                :disabled="desabilita"
                value
                placeholder="Nome completo"
                class="field-d"
                maxlength="50"
              />
              <small class="form-text text-muted">{{ errors.first('nome') }}</small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="colsm-2">
            <div class="control-item">
              <label class="label-d">CPF:</label>
              <input
                type="text"
                name="cpf"
                v-validate="'required|cpf'"
                :disabled="desabilita"
                v-mask="'###.###.###-##'"
                v-model="dados.vCPF"
                placeholder="000.000.000-00"
                @change="gerarProtocolo(dados)"
                class="field-d"
                maxlength="50"
              />
              <small class="form-text text-muted">{{ errors.first('cpf') }}</small>
            </div>
          </div>
          <div class="colsm-1"></div>
          <div class="colsm-2">
            <div class="control-item">
              <label class="label-d">Data de nascimento:</label>
              <input
                type="text"
                name="dtNascimento"
                v-validate="'date_format:dd/MM/yyyy|required|dateOld'"
                v-mask="'##/##/####'"
                v-model="dataNascimento"
                @change="formataData(dataNascimento)"
                placeholder="00/00/0000"
                class="field-d"
                maxlength="50"
              />
              <small class="form-text text-muted">{{ errors.first('dtNascimento') }}</small>
            </div>
          </div>
          <div class="colsm-1"></div>
          <div class="colsm-2">
            <div class="control-item">
              <label class="label-d">Número de celular:</label>
              <the-mask
                name="celular"
                v-validate="'required|length:11'"
                :mask="['(##) ####-####', '(##) #####-####']"
                v-model="dados.vTelefone"
                class="field-d"
                placeholder="(00) 00000-0000"
              />
              <small class="form-text text-muted">{{ errors.first('celular') }}</small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="colsm-8">
            <div class="control-item">
              <label class="label-d">E-mail:</label>
              <input
                type="text"
                v-validate="'required|email'"
                name="email"
                value
                placeholder="email@email.com.br"
                v-model="dados.vEmail"
                class="field-d"
                maxlength="50"
              />
              <small class="form-text text-muted">{{ errors.first('email') }}</small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="colsm-12">
            <div class="control-item">
              <label
                class="label-d"
                style="margin-bottom: 20px;"
              >Autorizo a CAIXA ECONÔMICA FEDERAL:</label>
              <div class="termo" style="margin-top: 15px;">
                <input type="checkbox" class="form-check-input" id="termoCheck" v-model="dados.termo" value="checkedValue" @change="check($event)"/>
                <label for="termoCheck">a entrar em contato ou enviar, por meio dos contatos cadastrados, informações e contratações referentes às propostas de crédito ou demais serviços ofertados pela CAIXA; a consultar e fornecer ao BACEN (Banco Central do Brasil) informações referentes às operações de crédito e câmbio constantes em meu nome no SCR (Sistema de Informação ao Credito), gerido pelo BACEN. Estou ciente que, ao clicar nesta autorização, concordo também com o termo do link a seguir: </label> (<a @click="modalTermos(dados,true)">saiba mais</a>).
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="colsm-8">
            <small class="form-text text-muted" v-if="erroTermo">É necessário aceitar os termos acima.</small>
            <small class="form-text text-muted" v-if="erroApi">Erro de comunicação com o servidor. Tente novamente mais tarde.</small>
          </div>
        </div>
        

        <div class="row">
          <div class="colsm-12">
            <a class="btn blue" @click="validarAvancar(dados)">Próxima Etapa</a>
            <div class="campo-obrigatorio">Atenção! Todos os campos são obrigatórios.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import axios from "axios";
import moment from "moment";
import {chatMixin} from '../../chat';

export default {
  name: "passo1",
  mixins:[chatMixin],
  data: function() {
    return {
      dados: {
        Nome: null,
        mSalario_Mensal: 0,
        mNecessidade_Valor: 0,
        termo: false,
        iID_Cliente: null,
        iID_Visita: null,
        iID_Objetivo: null,
        iID_Profissao: null,
        vProtocolo: null,
        iPasso_Simulador: 1,
        Visita_Dados_Garantias: [],
        keycloak: null
      },
      configs: null,
      desabilita: false,
      dataNascimento: null,
      error: null,
      erroApi: false,
      urlApi: process.env.VUE_APP_URL_API,
      erroTermo: false
    };
  },
  methods: {
    gerarProtocolo(dados) {
      var _this = this;

      if (_this.fields.cpf.valid) {
        _this.$loading(true);

        axios
          .post(_this.urlApi + "visitas/new", {
            CPF_CNPJ: _this.dados.vCPF,
            Forcar_Novo_Protocolo: true
          })
          .then(function(response) {
            _this.dados.iID_Visita = parseInt(response.data.iID_Visita);
            _this.dados.vProtocolo = response.data.vProtocolo;
            _this.dados.iID_Cliente = parseInt(response.data.iID_Cliente);
            _this.$loading(false);
          })
          .catch(function(error) {
            _this.erroApi = true;
            _this.$loading(false);
          });
      }
    },
    check(e){
      if(e.target.checked){
        this.erroTermo = false;

      } else {
        this.erroTermo = true;
      }
    },
    validarAvancar(dados) {
      var _this = this;
      _this.dados.iPasso_Simulador = 1;

      if(!_this.dados.termo){
        this.erroTermo = true;
      }

      _this.$validator.validate().then(valid => {
        if (valid && _this.dados.termo && _this.dados.iID_Visita) {
          this.$loading(true);
          axios
            .post(
              _this.urlApi + "Visita_Dados_PF/" + _this.dados.iID_Visita,
              _this.dados
            )
            .then(function(response) {
              
              try{
                dataLayer.push({
                  'passoSimulador': 'Passo1',
                  'event': 'proximoPasso',
                  'tipo': 'PF'
                });
              } catch(error){
                console.error(error);
              }

              _this.$router.push({ name: "passo-dois", params: { dados } });

              

              _this.$loading(false);
            })
            .catch(function(error) {
              _this.erroApi = true;
              _this.$loading(false);
            });
        }
      });
      return false;
    },
    formataData(data) {
      var _this = this;
      _this.dados.dData_Nascimento = moment(
        _this.dataNascimento,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD");
    },
    modalTermos(dados, link) {
      if (dados.termo || link) {
        this.$modal.show("termo", this.dados);
      }
    },
    retornoModal(x) {
      if (x) {
        //this.dados.termo = true;
        this.$modal.hide("termo", this.dados);
      } else {
        //this.dados.termo = false;
        this.$modal.hide("termo", this.dados);
      }
    }
  },
  created: function() {
    var _this = this;
    _this.$loading(true);

    this.registrarChat();

    axios
      .get(_this.urlApi + "Parametros_Gerais")
      .then(function(response) {
        if(!response.data.bPortal_Ativado){
          _this.$modal.show("appDesabilitado");
        }
        _this.$loading(false);
      })
      .catch(function(error) {
        _this.erroApi = true;
        _this.$loading(false);
      });
      if(_this.$keycloak){
        if(_this.$keycloak.authenticated){

        _this.$loading(true);
        _this.desabilita = true;
        _this.dados.vCPF = _this.$keycloak.tokenParsed.SIPER.cpf;

        axios
          .post(_this.urlApi + "visitas/new", {
            CPF_CNPJ: _this.dados.vCPF
          })
          .then(function(response) {
            if (response.data.Visita_Dados_PF) {
              _this.dados = response.data.Visita_Dados_PF;
              _this.dados.vProtocolo = response.data.vProtocolo;
              _this.dados.Nome = _this.$keycloak.tokenParsed.SIPER.nome;
              _this.dados.vToken = _this.$keycloak.token;
              _this.dados.keycloak = _this.$keycloak;
              _this.dataNascimento = moment(
                response.data.Visita_Dados_PF.dData_Nascimento
              ).format("DD/MM/YYYY");
            } else {
              _this.dados.iID_Visita = parseInt(response.data.iID_Visita);
              _this.dados.vProtocolo = response.data.vProtocolo;
              _this.dados.iID_Cliente = parseInt(response.data.iID_Cliente);
              _this.dados.Nome = _this.$keycloak.tokenParsed.SIPER.nome;
              _this.dados.vToken = _this.$keycloak.token;
              _this.dados.keycloak = _this.$keycloak;
            }
            _this.$loading(false);
          })
          .catch(function(error) {
            _this.erroApi = true;
            _this.$loading(false);
          });
          var dados = _this.dados;
          _this.$router.push({ name: "passo-um", params: { dados } });
      }
      }
      
    


    if (this.$route.params.dados) {
      this.dados = this.$route.params.dados;
      this.dataNascimento = moment(
      this.$route.params.dados.dData_Nascimento
      ).format("DD/MM/YYYY");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.termo a {
  cursor: pointer;
}
.campo-obrigatorio{
  float: right;
  margin-top: 50px;
  font-size: 13px;
}

/*  TABLET */
@media only screen and (max-width: 1026px) {
}

@media only screen and (max-width: 770px) {
}
/* MOBILE */

/* IPHONE 6 PLUS*/
@media only screen and (max-width: 645px) {
}
/* IPHONE 6 */
@media only screen and (max-width: 480px) {
}

/* IPHONE 5*/
@media only screen and (max-width: 328px) {
}
</style>